






















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Echarts from "./Echarts.vue";

class PageWareHouseAnalyseRequest extends PageRequest {
  FilterText: string;
  cId: Number;
  StartTime: string;
  EndTime: string;
}
class PageCompanyRequest {
  cId: Number;
}
class DataTable {
  public columns: Array<string> = new Array<string>();
}

@Component({
  components: { Echarts },
})
export default class WareHouseAnalyses extends AbpBase {
  pagerequest: PageWareHouseAnalyseRequest = new PageWareHouseAnalyseRequest();
  table: DataTable = new DataTable();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  userName: string;
  cId: Number;
  selTime: Array<string>;
  componentKey: number = 0;
  datalist = [];
  legenddata: string = "";
  xAxisdata: string = "";
  seriesdata: string = "";
  serieslist = [];
  
  exportData() {
    this.$refs.table.exportCsv({
      filename: "各库房烟虫数据"+this.pagerequest.StartTime+'_'+this.pagerequest.EndTime,
    });
  }
  get spannumber(){
    if(this.userName=='admin'){
      return 8;
    }else{
      return 12;
    }
  }
  onClickTime(value, date) {
    this.pagerequest.StartTime = value[0];
    this.pagerequest.EndTime = value[1];
  }
  showEcharts() {
    this.componentKey += 1;
  }
  list() {
    return this.$store.state.data.list;
  }
  get loading() {
    return this.$store.state.data.loading;
  }
  selCompany(value: Number) {
    this.pagecompanyrequest.cId = value;
    this.pagerequest.cId = value;
    this.getwarehouse();
  }
  async getpage() {
    //filters
    //console.log(this.pagerequest.StartTime);
    let ret = await this.$store.dispatch({
      type: "data/getWareHouseList",
      data: this.pagerequest,
    });
    if (ret == 1) {
      let list = this.list();
      //console.log(list);
      var eventStartTime = new Date(this.pagerequest.StartTime);
      var eventEndTime = new Date(this.pagerequest.EndTime);
      var time = eventStartTime;
      var duration = eventEndTime.valueOf() - eventStartTime.valueOf();
      duration = duration / 1000 / 60 / 60 / 24 + 1;
      let temp = "";
      let timelist = [];
      //console.log(this.serieslist);
      for (let i = 0; i < duration; i++) {
        //console.log(this.GMTToStr(time));
        timelist.push(this.GMTToStr(time));
        if (temp != "") {
          temp += ",";
        }
        let row = "{";
        row += '"nowTime":"' + this.GMTToStr(time) + '"';
        let i = 0;
        for (let entry of this.table.columns) {
          //console.log(entry);
          let number = 0;
          let wId = "";
          for (let item of list) {
            wId = "wh_" + item.wId;
            if (
              this.GMTToStr(item.nowTime) == this.GMTToStr(time) &&
              wId == entry
            ) {
              number = item.number;
              break;
            }
          }
          //console.log(i);
          this.serieslist[i].data.push(number);
          i++;
          row += ',"' + entry + '":' + number + "";
        }
        row += "}";
        temp += row;
        time.setDate(time.getDate() + 1);
      }
      this.seriesdata = JSON.stringify(this.serieslist);
      this.datalist = JSON.parse("[" + temp + "]");
      this.xAxisdata = JSON.stringify(timelist);
      this.showEcharts();
    }
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  GMTToStr(time) {
    let date = new Date(time);
    let Str =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    return Str;
  }
  columns = [];
  nowTime = {
    title: "采集时间",
    key: "nowTime",
    width: 100,
    fixed: "left",
    render: (h, params) => {
      var date = params.row.nowTime;
      if (date === undefined) {
        return "";
      }
      return h("span", this.GMTToStr(date));
    },
  };
  warehouse() {
    return this.$store.state.warehouse.list;
  }
  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
    });
  }
  async getwarehouse() {
    //库房
    //filters
    let ret = await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
    if (ret == 1) {
      this.assemblecolumns();
    }
  }
  assemblecolumns() {
    let wlist = this.warehouse();
    let titlelist = [];
    this.columns = [];
    this.columns.push(this.nowTime);
    this.serieslist = [];
    this.table.columns = [];
    for (let entry of wlist) {
      titlelist.push(entry.wName);
      this.table.columns.push("wh_" + entry.id);
      this.columns.push({
        title: entry.wName,
        key: "wh_" + entry.id,
      });
      this.serieslist.push({
        name: entry.wName,
        type: "line",
        data: [],
      });
    }
    this.legenddata = JSON.stringify(titlelist);
    this.getpage();
  }
  GetTime(obj) {
    let date = new Date();
    let day = "01";
    if (obj == 1) {
      day = date.getDate() + "";
    }
    let Str = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + day;
    //date.getDate();
    return Str;
  }
  created() {
    this.pagerequest.StartTime = this.GetTime(0);
    this.pagerequest.EndTime = this.GetTime(1);
    this.selTime = [this.pagerequest.StartTime, this.pagerequest.EndTime];
    this.getuserName();
    if (this.userName !== "admin") {
      this.getwarehouse();
      // this.getpage();
    } else {
      this.getcompany();
    }
  }
}
